import { ChangeDetectionStrategy, Component, EventEmitter, Injector, Input, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessor } from '../../value-accessor/value-accessor';

@Component({
    selector: 'sera-checkbox',
    templateUrl: './sera-checkbox.component.html',
    styleUrls: ['./sera-checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SeraCheckboxComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SeraCheckboxComponent extends ValueAccessor<boolean> {
    @Input()
    inputId!: string;

    @Input()
    inputStyle: string = '';

    @Input()
    label!: string;

    @Input()
    name!: string;

    @Input()
    binary: boolean = true;

    @Input()
    required: boolean = false;

    @Input()
    isDisabled: boolean = false;

    @Input()
    readOnly: boolean = false;

    @Input()
    densityCheckbox: boolean = false;

    @Output() stateChanged = new EventEmitter<boolean>();

    constructor(injector: Injector) {
        super(injector);
    }

    stopPropagation(event: MouseEvent): void {
        event.stopPropagation();
    }

    handleClick(event: MouseEvent, value: boolean): void {
        this.stopPropagation(event);
        this.changeValue(value);
    }

    changeValue(value: boolean) {
        this.value = this.densityCheckbox ? !value : value;
        if (this.densityCheckbox) this.stateChanged.emit(value);
    }
}
